<script>
  import { createEventDispatcher, tick } from 'svelte';
  import {
    defaultValue,
    normalizeValue,
    getSchemaComponent,
    getSchemaComponentProps,
    getComponent,
    getComponentProps
  } from './helpers';
  export let id;
  export let schema;
  export let ui;
  export let value = null;
  export let components;
  export let validator;
  let errors = null;
  const dispatch = createEventDispatcher();
  const iterate = (obj, v) => {
      Object.keys(obj).forEach(key => {
          if (obj[key]["ui:disabled"]) {
            delete v[key];
          }
          if (typeof obj[key] === "object" && typeof v[key] === "object") {
              iterate(obj[key], v[key])
          }
      })
  }
  const iterateSchema = (obj, v) => {
      Object.keys(obj).forEach(key => {
        console.log(obj[key]);
        console.log(v[key]);
          if (typeof obj[key] === "object" && obj[key].properties && v[key]) {
              iterateSchema(obj[key].properties, v[key])
          }
          if (obj[key].format == "date") {
            console.log(v[key]);
            if (v[key]) {
              var timestamp = Date.parse(v[key]);
              console.log(timestamp);
              if (isNaN(timestamp) || timestamp < 0 || timestamp > 4102444800000) {
                errors = key + ": Invalid date";
              }
            }
          }
      })
  }
  const submit = (e) => {
      /*if (!validator) {
          throw new Error('Missing a "validator" property');
      }*/
      //console.log('Form submit event', e);
      const v = normalizeValue(value);
      //errors = validator(schema, v);
      errors = null;

      iterate(ui, v);
      iterateSchema(schema.properties, v);
      if (errors) {
          dispatch('error', errors);
          console.log('Form error', errors);
      }
      else {
          //console.log('Form submit', v);
          dispatch('submit', v);
      }
  };
  const reset = async (e) => {
      errors = null;
      Object.keys(schema.properties).map(function (key) {
        if (schema.properties[key].description == "section") {
          Object.keys(schema.properties[key].properties).map(function (field) {
            if (schema.properties[key].properties[field].description == "reset") {
              value[key][field] = schema.properties[key].properties[field].default ? schema.properties[key].properties[field].default : null;
            }
          })
        } else if (schema.properties[key].description == "reset") {
          value[key] = schema.properties[key].default ? schema.properties[key].default : null;
        }
      })
      await tick();
      dispatch('reset', normalizeValue(value));
  };
  if (components && validator) {
      components = Object.assign(Object.assign({}, components), { form: [getComponent(components.form), Object.assign({ validator }, getComponentProps(components.form))] });
  }
</script>

<form id={id} on:submit|preventDefault={submit} on:reset|preventDefault={reset}>
  <svelte:component
    this={getComponent(components.layout)}
    {...getComponentProps(components.layout)}>
    <div slot="fields">
      <svelte:component
        this={getSchemaComponent(schema, components)}
        props={getSchemaComponentProps(schema, components)}
        {components}
        {schema}
        {ui}
        bind:value
        {errors} />
    </div>
    <div slot="ctrl">
      <slot />
    </div>
  </svelte:component>
</form>
